<template>
  <div class="common-header">
    <p class="left-action" @click="goBack">
      <img :src="backIcon" alt="返回图标" />
      <span>返回</span>
    </p>
    <p class="right-action">
      <slot>
        <img :class="iconClass" :src="rightIcon" alt />
        <span>{{ iconClass | rightText }}</span>
      </slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'common-header',
  props: {
    iconClass: {
      type: String,
      default: 'check',
      comment: '显示的图表类型[check, create, editor, adjust]'
    },
    url: {
      type: String,
      default: '',
      comment: '返回的路径'
    },

    id: {
      type: String,
      default: '',
      comment: 'T6账户管控传过来的id'
    },

    periodNo: {
      type: String,
      default: '',
      comment: '返回的期号'
    }
  },
  data() {
    return {
      backIcon: require('@/assets/back.png'),
      rightIcon: require(`@/assets/${this.iconClass}.png`)
    }
  },

  filters: {
    rightText(value) {
      switch (value) {
        case 'check':
          return '查看'
        case 'create':
          return '新增'
        case 'editor':
          return '修改'
        case 'adjust':
          return '调控'
      }
    }
  },

  created() {
    // console.log(this.$route)
  },

  methods: {
    goBack() {
      const { url, id, periodNo } = this

      if (url === 'accountControl' && id != '') {
        // T6 账户管控 子页面
        this.$router.push({
          path: `/home/accountControl/details/${this.id}`
        })
      } else if (url === 'profitFee/details' && id != '' && periodNo != '') {
        // T6 手续费利润 子页面
        this.$router.push({
          path: `/home/profitFee/details/${id}/${periodNo}`,
          query: {
            periodNo: periodNo
          }
        })
      } else if (this.url != '') {
        this.$router.push({ path: '/home/' + this.url })
      } else {
        this.$router.back()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.common-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  padding: 10px;

  .left-action {
    cursor: pointer;
  }

  .left-action,
  .right-action {
    display: flex;
    align-items: center;

    img {
      width: 20px;

      &.check {
        height: 14px;
      }

      &.adjust {
        width: 18px;
        height: 16px;
      }
    }

    span {
      margin: 0 5px;
    }
  }
}
</style>
